import React, { useState, useEffect } from 'react';
import API_URL from '../../apiConfig';

const Temoignages = () => {
    const [temoignages, setTemoignages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [message, setMessage] = useState("");
    
    const [formData, setFormData] = useState({
        nom: '',
        role: '',
        message: '',
        stars: 5,
        initials: '',
        color: '#1700E2'
    });

    const colors = [
        { name: 'Bleu', hex: '#1700E2' },
        { name: 'Or', hex: '#f59e0b' },
        { name: 'Emeraude', hex: '#10b981' },
        { name: 'Violet', hex: '#8b5cf6' },
        { name: 'Rose', hex: '#ec4899' },
        { name: 'Rouge', hex: '#ef4444' }
    ];

    const fetchTemoignages = async (isSilent = false) => {
        try {
            if (!isSilent) setLoading(true);
            const res = await fetch(`${API_URL}/api/temoignages/all`);
            const data = await res.json();
            if (data.success) setTemoignages(data.temoignages);
        } catch (err) {
            console.error("Erreur fetch temoignages:", err);
        } finally {
            if (!isSilent) setLoading(false);
        }
    };

    useEffect(() => {
        document.title = "LAMP | Admin - Témoignages";
        fetchTemoignages();
    }, []);

    const handleInput = (e) => {
        const { name, value } = e.target;
        
        if (name === 'nom') {
            const parts = value.trim().split(' ');
            let init = '';
            if (parts.length > 1 && parts[0] && parts[1]) {
                init = (parts[0][0] + parts[1][0]).toUpperCase();
            } else if (parts[0]) {
                init = parts[0][0].toUpperCase();
            }
            setFormData(prev => ({ ...prev, nom: value, initials: init }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleEdit = (t) => {
        setEditingId(t.id_tem);
        setFormData({
            nom: t.nom,
            role: t.role,
            message: t.message,
            stars: t.stars,
            initials: t.initials,
            color: t.color
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const resetForm = () => {
        setEditingId(null);
        setFormData({ nom: '', role: '', message: '', stars: 5, initials: '', color: '#1700E2' });
        setMessage("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage("");

        const url = editingId ? `${API_URL}/api/temoignages/${editingId}` : `${API_URL}/api/temoignages/add`;
        const method = editingId ? 'PUT' : 'POST';

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'include'
            });
            const data = await res.json();
            if (data.success) {
                setMessage(editingId ? "✅ Modifié !" : "✅ Ajouté !");
                resetForm();
                fetchTemoignages(true);
            } else {
                setMessage("❌ Erreur : " + data.message);
            }
        } catch (err) {
            setMessage("❌ Erreur de connexion.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("🗑️ Supprimer ce témoignage ?")) return;
        try {
            const res = await fetch(`${API_URL}/api/temoignages/${id}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            const data = await res.json();
            if (data.success) fetchTemoignages(true);
        } catch (err) {
            console.error("Erreur delete:", err);
        }
    };

    return (
        <div className="container-fluid py-4 animate__animated animate__fadeIn">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="fw-bold outfit text-dark mb-0">⭐ Gestion des Témoignages</h2>
                <span className="badge bg-primary px-3 py-2 rounded-pill shadow-sm">
                    {temoignages.length} {temoignages.length > 1 ? 'témoignages' : 'témoignage'}
                </span>
            </div>

            <div className="row g-4">
                {/* Formulaire - Col 5 */}
                <div className="col-lg-5">
                    <div className="card-custom border-0 shadow-sm p-4 rounded-4 bg-white sticky-top" style={{ top: '20px' }}>
                        <h5 className="fw-bold mb-4 text-primary">
                            <i className={`bi ${editingId ? 'bi-pencil-square' : 'bi-plus-circle-fill'} me-2`}></i>
                            {editingId ? "Modifier le Témoignage" : "Nouveau Témoignage"}
                        </h5>
                        
                        <form onSubmit={handleSubmit} className="row g-3">
                            <div className="col-12 mb-2">
                                <label className="small fw-bold text-muted text-uppercase mb-1">Nom Complet</label>
                                <input type="text" name="nom" className="form-control bg-light border-0 p-3 rounded-3" value={formData.nom} onChange={handleInput} required />
                            </div>
                            <div className="col-12 mb-2">
                                <label className="small fw-bold text-muted text-uppercase mb-1">Fonction / Rôle</label>
                                <input type="text" name="role" className="form-control bg-light border-0 p-3 rounded-3" value={formData.role} onChange={handleInput} required placeholder="Ex: Membre" />
                            </div>
                            <div className="col-12 mb-2">
                                <label className="small fw-bold text-muted text-uppercase mb-1">Témoignage</label>
                                <textarea name="message" className="form-control bg-light border-0 p-3 rounded-3" rows="3" value={formData.message} onChange={handleInput} required></textarea>
                            </div>
                            
                            <div className="col-md-6 mb-2">
                                <label className="small fw-bold text-muted text-uppercase mb-1">Note (1-5)</label>
                                <select name="stars" className="form-select bg-light border-0 p-3 rounded-3" value={formData.stars} onChange={handleInput}>
                                    {[5,4,3,2,1].map(n => <option key={n} value={n}>{n} Étoiles</option>)}
                                </select>
                            </div>
                            
                            <div className="col-md-6 mb-2">
                                <label className="small fw-bold text-muted text-uppercase mb-1">Initials</label>
                                <input type="text" name="initials" className="form-control bg-light border-0 p-3 rounded-3" maxLength="2" value={formData.initials} onChange={handleInput} />
                            </div>

                            <div className="col-12 mb-3">
                                <label className="small fw-bold text-muted text-uppercase mb-2">Couleur de l'Avatar</label>
                                <div className="d-flex gap-2 flex-wrap">
                                    {colors.map(c => (
                                        <div 
                                            key={c.hex} 
                                            onClick={() => setFormData(prev => ({ ...prev, color: c.hex }))}
                                            style={{ 
                                                width: '32px', height: '32px', backgroundColor: c.hex, 
                                                cursor: 'pointer', borderRadius: '50%',
                                                border: formData.color === c.hex ? '3px solid #1700E2' : '2px solid white',
                                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="col-12 d-flex gap-2 pt-2">
                                <button type="submit" disabled={isSubmitting} className={`btn ${editingId ? 'btn-primary' : 'btn-success'} w-100 py-3 fw-bold rounded-3 shadow-none`}>
                                    {isSubmitting ? "CHARGEMENT..." : editingId ? "METTRE À JOUR" : "ENREGISTRER"}
                                </button>
                                {editingId && (
                                    <button type="button" className="btn btn-light border px-4 rounded-3" onClick={resetForm}>X</button>
                                )}
                            </div>
                        </form>

                        {message && (
                            <div className={`mt-3 p-3 small text-center rounded-3 animate__animated animate__headShake ${message.includes('✅') ? 'bg-success text-white' : 'bg-danger text-white'}`}>
                                {message}
                            </div>
                        )}
                    </div>
                </div>

                {/* Liste - Col 7 */}
                <div className="col-lg-7">
                    {loading ? (
                        <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                    ) : (
                        <div className="row g-3">
                            {temoignages.map(t => (
                                <div key={t.id_tem} className="col-md-6">
                                    <div className="card-custom border-0 shadow-sm p-4 bg-white rounded-4 h-100 transition position-relative">
                                        <div className="position-absolute top-0 end-0 m-3 d-flex gap-1">
                                            <button onClick={() => handleEdit(t)} className="btn btn-xs btn-light text-primary rounded-circle border-0 shadow-sm"><i className="bi bi-pencil"></i></button>
                                            <button onClick={() => handleDelete(t.id_tem)} className="btn btn-xs btn-light text-danger rounded-circle border-0 shadow-sm"><i className="bi bi-trash"></i></button>
                                        </div>

                                        <div className="text-warning mb-3">
                                            {[...Array(t.stars)].map((_, i) => <i key={i} className="bi bi-star-fill me-1 small"></i>)}
                                        </div>
                                        
                                        <p className="text-muted mb-4 small italic flex-grow-1" style={{ fontSize: '0.85rem', lineHeight: '1.6' }}>"{t.message}"</p>
                                        
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold shadow-sm" 
                                                style={{ width: '45px', height: '45px', background: `linear-gradient(135deg, ${t.color} 0%, ${t.color}99 100%)`, fontSize: '0.9rem' }}>
                                                {t.initials}
                                            </div>
                                            <div>
                                                <h6 className="mb-0 fw-bold outfit" style={{ fontSize: '0.95rem' }}>{t.nom}</h6>
                                                <span className="text-muted" style={{ fontSize: '0.75rem' }}>{t.role}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {temoignages.length === 0 && (
                                <div className="col-12 text-center py-5 bg-white rounded-4 shadow-sm border-dashed border-2">
                                    <i className="bi bi-chat-quote fs-1 text-muted opacity-25"></i>
                                    <p className="text-muted mt-2">Aucun témoignage pour le moment.</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <style>{`
                .italic { font-style: italic; }
                .btn-xs { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; }
                .card-custom:hover { transform: translateY(-5px); }
            `}</style>
        </div>
    );
};

export default Temoignages;
